/* eslint-env jest */
import shouldShowFreeMagnets, { afterElementaryBuildRoute } from './freeMagnetsVisibility';

const magnets = { couponType: 'FREE_MAGNETS_WITH_FREE_SHIPPING', value: 0 };
const pct = { couponType: 'PERCENTAGE_WITH_FREE_SHIPPING', value: 20 };

describe('shouldShowFreeMagnets (issue #5218 item 8)', () => {
  it('shows when the magnet tier is live and the fresh status qualifies', () => {
    expect(shouldShowFreeMagnets({
      offer: magnets, qualifies: true, hasFreeMagnets: false, allJpg: false,
    })).toBe(true);
  });

  it('hides for every other offer, and for no offer', () => {
    expect(shouldShowFreeMagnets({ offer: pct, qualifies: true, hasFreeMagnets: false, allJpg: false })).toBe(false);
    expect(shouldShowFreeMagnets({ offer: null, qualifies: true, hasFreeMagnets: false, allJpg: false })).toBe(false);
  });

  it('requires an EXPLICIT true qualifies -- undefined/false/"true" hide', () => {
    expect(shouldShowFreeMagnets({ offer: magnets, qualifies: undefined, hasFreeMagnets: false, allJpg: false })).toBe(false);
    expect(shouldShowFreeMagnets({ offer: magnets, qualifies: false, hasFreeMagnets: false, allJpg: false })).toBe(false);
    expect(shouldShowFreeMagnets({ offer: magnets, qualifies: 'true', hasFreeMagnets: false, allJpg: false })).toBe(false);
  });

  it('hides once the cart already carries the free sheet', () => {
    expect(shouldShowFreeMagnets({ offer: magnets, qualifies: true, hasFreeMagnets: true, allJpg: false })).toBe(false);
  });

  it('never shows for an all-JPG session', () => {
    expect(shouldShowFreeMagnets({ offer: magnets, qualifies: true, hasFreeMagnets: false, allJpg: true })).toBe(false);
  });
});

describe('afterElementaryBuildRoute', () => {
  it("routes a family's FIRST package to the magnet page from the fresh post-build status", () => {
    // The cached cart said qualifies=false before the build; the build response
    // says true. Only the fresh status is consulted.
    const route = afterElementaryBuildRoute({
      next: '/confirm/77',
      orderPackageId: 77,
      offer: magnets,
      status: { qualifies: true, hasFreeMagnets: false },
      allJpg: false,
    });
    expect(route).toBe('/elementary-multi-pose/free-magnets/77?next=%2Fconfirm%2F77');
  });

  it('goes straight on when the gate says no, with no status, or with no order package', () => {
    const base = {
      next: '/confirm/77', orderPackageId: 77, offer: magnets, allJpg: false,
    };
    expect(afterElementaryBuildRoute({ ...base, offer: pct, status: { qualifies: true } })).toBe('/confirm/77');
    expect(afterElementaryBuildRoute({ ...base, status: undefined })).toBe('/confirm/77');
    expect(afterElementaryBuildRoute({ ...base, status: { qualifies: true, hasFreeMagnets: true } })).toBe('/confirm/77');
    expect(afterElementaryBuildRoute({ ...base, orderPackageId: null, status: { qualifies: true } })).toBe('/confirm/77');
  });
});
